// Fecha a partir de la cual los numeros del sistema cuadran al centavo contra
// los Excel que ya se pagaron. Vive aqui sola para que no quede escrita en dos
// pantallas y una se quede vieja cuando cambie.
//
// Antes del 22 de agosto un reporte va a diferir por dos razones, y ninguna es
// un error del sistema:
//
//   1. Las reglas de comision se terminaron de definir a principios de octubre.
//      Los Excel de julio y de la primera mitad de agosto se armaron con
//      criterios que todavia se estaban discutiendo; el del 26 de julio al 7 de
//      agosto incluso trae una hoja de "Diferencias vs Rosamalia".
//
//   2. Odoo siguio cambiando despues de que esos cortes se liquidaron. Hay por
//      lo menos una nota de credito, la CN/2026/0021, que aparecio despues del
//      8 de octubre y que altera un periodo ya pagado.
//
// Verificado: los periodos 08-22 al 09-04, 09-05 al 09-18 y 09-19 al 10-02
// cuadran al centavo, antes y despues de los cambios de tarifa de octubre.
export const CUADRA_DESDE = '2026-08-22';

export function avisoDeFecha(desde) {
  if (!desde || String(desde).slice(0, 10) >= CUADRA_DESDE) return null;
  return 'Este periodo empieza antes del ' + CUADRA_DESDE + '. Los numeros del '
       + 'sistema cuadran al centavo con lo que ya se pago a partir de esa fecha; '
       + 'para fechas anteriores va a haber diferencias, porque las reglas de '
       + 'comision se terminaron de definir en octubre y porque Odoo siguio '
       + 'cambiando despues de que esos periodos se liquidaron. Sirve para '
       + 'consultar, no para pagar ni para comparar contra lo ya pagado.';
}

// Regla de operacion, no de software.
//
// Una nota de credito con fecha de un mes anterior no descuenta comision en
// ninguna parte: el corte de ese periodo ya esta cerrado y congelado, asi que la
// reversa no entra ahi, y el corte en curso selecciona las notas por su fecha de
// emision, asi que tampoco entra aqui. Se queda sin comisionar en los dos y hay
// que capturarla a mano como ajuste, con su motivo.
//
// El sistema se va a arreglar para que seleccione las notas por fecha de
// APLICACION y no de emision, que cierra el hueco de las que ya existen. Pero
// aun con eso arreglado, una nota con fecha vieja obliga a un ajuste manual en
// lugar de salir sola, asi que la regla se queda: se capturan en el mes en curso.
export const NOTA_NOTAS_DE_CREDITO =
  'Las notas de credito se capturan con fecha del MES EN CURSO, nunca con fecha de '
  + 'un mes anterior. Una nota fechada en un periodo ya cerrado no descuenta '
  + 'comision en ese corte, porque esta congelado, ni en el actual, y hay que '
  + 'corregirla a mano como ajuste.';
